import { ActionEnum } from '../../../actions/types/orderActions.types';
import { SelectedOrderWithActions } from '../types/orderListMassActions.types';

abstract class OrderMassAction {
  constructor(private readonly orders: SelectedOrderWithActions[]) {}

  protected allOrdersHaveAction(actionsToVerify: ActionEnum[]): boolean {
    return this.orders.every((order) =>
      order.actions.some((action) => actionsToVerify.includes(action.value)),
    );
  }

  public abstract mustShowAction(): boolean;
}

export default OrderMassAction;
